import {
  fetchPostPaymentMethod,
  PostPaymentMethodRequestBody,
} from '@iwoca/lapi-client/edge';

export const createPaymentMethod = async ({
  accountNumber,
  sortCode,
  stateKey,
}: {
  accountNumber: string;
  sortCode: string;
  stateKey: string;
}) => {
  try {
    const payload: PostPaymentMethodRequestBody = {
      data: {
        bank_details: {
          account_number: accountNumber,
          sort_code: sortCode,
        },
        roles: { funding: 'enabled', repayment: 'disabled' },
      },
    };

    await fetchPostPaymentMethod({ stateKey, body: payload });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    if (e.statusCode === 400) {
      return;
    }

    throw e;
  }
};
